import hide from './hide';
import show from './show';

export default {
  show,
  hide,
};
